import $ from 'jquery'
// import '../vendors/orejime.js';
import inView from 'in-view'
import lazyLoad from '../util/lazyLoad';
import Orejime from '../vendors/orejime.js';

export default {
    init () {
        // JavaScript to be fired on all pages
        lazyLoad.init()

        // Scroll spy
        inView('.scroll-spy').on(
            'enter',
            element => {
                element.classList.add('enter')
            }
        )
    },
    finalize () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        // document click
        $(document).on('click', function (e) {
            $('body').removeClass('search-open');
            // e.stopPropagation()
        });

        // menu actions
        if ($('.btn-menu').length > 0) {
            $('.btn-menu').on('click', function () {
                $('body').addClass('menu-open')

                return false
            })
        }

        if ($('.btn-close-menu').length > 0) {
            $('.btn-close-menu').on('click', function () {
                $('body').removeClass('menu-open')

                return false
            })
        }

        $('.scroll-top').on('click', function (e) {
            e.preventDefault();

            $('html, body').animate(
                { scrollTop: 0 },
                500,
                'linear'
            )
        })

        $(window).on('load', () => {
            $('.main-menu').removeClass('hidden')
        })

        // Window open
        $('[data-behavior="openWindow"]').each(
            function () {
                $(this).click(
                    function () {
                        window.open($(this).attr('href'), '_blank', 'width=600,height=600')

                        return false
                    }
                )
            }
        );

        // Anchor
        $('[data-behavior="anchor"]').each(
            function () {
                $(this).click(
                    function () {
                        const targetId = $(this).attr('href')
                        const targetElement = $(targetId)

                        if (targetElement.length) {
                            const targetPosition = targetElement.offset().top

                            $([document.documentElement, document.body]).animate(
                                { scrollTop: targetPosition },
                                { duration: 250 }
                            )
                        }

                        return false
                    }
                )
            }
        );

        // Search
        $('.btn-search, .search-field').on('click', function (e) {
            $('html, body').animate(
                { scrollTop: 0 },
                500,
                'linear'
            )

            $('body').addClass('search-open');
            $('.search-field').focus();
            e.stopPropagation()
        });
    }
}
